module.exports = __webpack_public_path__ + "static/media/tear-pads2.8aec8831.png";